export const ACCEPTED_FILE_TYPES = ".xlsx, .xls, .csv";
